export const NGX_LOGO = "https://customer-assets-v7afamib.emergentagent.net/job_automation-decision/artifacts/b19jzgwi_ChatGPT_Image_12_08_2026__22_16_30-removebg-preview.png";
